import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=31277ba5"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports